<template>
	<TransitionRoot
		as="template"
		:show="open">
		<Dialog
			as="div"
			class="relative z-50"
			:initial-focus="dialogPanelRef"
			:static
			@close="static ? null : onClose()">
			<TransitionChild
				as="template"
				enter="ease-out duration-100"
				enter-from="opacity-0"
				enter-to="opacity-100"
				leave="ease-in duration-100"
				leave-from="opacity-100"
				leave-to="opacity-0">
				<div class="fixed inset-0 flex w-screen justify-center overflow-y-auto bg-zinc-950/15 px-2 py-2 focus:outline-0 sm:px-6 sm:py-8 lg:px-8 lg:py-16 dark:bg-zinc-950/50" />
			</TransitionChild>

			<div class="fixed inset-0 w-screen overflow-y-auto pt-6 sm:pt-0">
				<div class="grid min-h-full grid-rows-[1fr_auto_1fr] justify-items-center p-8 sm:grid-rows-[1fr_auto_3fr] sm:p-4">
					<TransitionChild
						as="template"
						enter="ease-out duration-100"
						enter-from="opacity-0 scale-95"
						enter-to="opacity-100 scale-100"
						leave="ease-in duration-100"
						leave-from="opacity-100"
						leave-to="opacity-0">
						<DialogPanel
							ref="dialogPanelRef"
							:class="clsx(
								className,
								sizes[size],
								'row-start-2 w-full rounded-2xl bg-white p-8 shadow-lg ring-1 ring-zinc-950/10 sm:rounded-2xl sm:p-6 dark:bg-zinc-900 dark:ring-white/10 forced-colors:outline')">
							<slot />
						</DialogPanel>
					</TransitionChild>
				</div>
			</div>
		</Dialog>
	</TransitionRoot>
</template>

<script setup lang="ts">
	import {
		clsx,
	} from "clsx"

	import {
		Dialog,
		DialogPanel,
		TransitionChild,
		TransitionRoot,
	} from "@headlessui/vue"

	import {
		ref,
	} from "vue"

	const props = defineProps({
		className: {
			type: String,
			default: "",
		},
		onClose: {
			type: Function,
			default: () => { return },
		},
		open: {
			type: Boolean,
			default: false,
		},
		size: {
			type: String,
			default: "md",
		},
		static: {
			type: Boolean,
			default: false,
		},
	})

	const dialogPanelRef = ref(null)

	const sizes: { [k: string]: string } = {
		xs: "sm:max-w-xs",
		sm: "sm:max-w-sm",
		md: "sm:max-w-md",
		lg: "sm:max-w-lg",
		xl: "sm:max-w-xl",
		"2xl": "sm:max-w-2xl",
		"3xl": "sm:max-w-3xl",
		"4xl": "sm:max-w-4xl",
		"5xl": "sm:max-w-5xl",
	}
</script>